/**
 * Printer Queue Status code class.
 */
export enum PrinterQueueStatus {
  TO_PRINT = "TO_PRINT",
  PRINTED = "PRINTED",
  CANCELED = "CANCELED",
}
